module.exports = __webpack_public_path__ + "img/ic_12_check_white.a19c93e4.svg";